import { apiFetch } from "./client";
import type { UserRole } from "./auth";

export interface UserAssignedPhone {
  id: string;
  name: string;
}

export interface AdminUser {
  id: string;
  email: string;
  name: string;
  role: UserRole;
  is_active: boolean;
  last_login_at: string | null;
  created_at: string;
  updated_at: string;
  assigned_phones: UserAssignedPhone[];
}

interface ListResponse  { success: boolean; users: AdminUser[]; }
interface SingleResponse { success: boolean; user: AdminUser; }

export async function listUsers(): Promise<AdminUser[]> {
  const data = await apiFetch<ListResponse>("/api/users");
  return data.users;
}

export async function getUser(id: string): Promise<AdminUser> {
  const data = await apiFetch<SingleResponse>(`/api/users/${id}`);
  return data.user;
}

export interface CreateUserPayload {
  email: string;
  name: string;
  password: string;
  role?: UserRole;
  phone_ids?: string[];
}

export async function createUser(payload: CreateUserPayload): Promise<AdminUser> {
  const data = await apiFetch<SingleResponse>("/api/users", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return data.user;
}

export interface UpdateUserPayload {
  name?: string;
  role?: UserRole;
  is_active?: boolean;
}

export async function updateUser(id: string, payload: UpdateUserPayload): Promise<AdminUser> {
  const data = await apiFetch<SingleResponse>(`/api/users/${id}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
  return data.user;
}

export async function resetUserPassword(id: string, newPassword: string): Promise<void> {
  await apiFetch(`/api/users/${id}/password`, {
    method: "POST",
    body: JSON.stringify({ new_password: newPassword }),
  });
}

export async function setUserPhones(id: string, phoneIds: string[]): Promise<AdminUser> {
  const data = await apiFetch<SingleResponse>(`/api/users/${id}/phones`, {
    method: "PUT",
    body: JSON.stringify({ phone_ids: phoneIds }),
  });
  return data.user;
}

export async function deleteUser(id: string): Promise<void> {
  await apiFetch(`/api/users/${id}`, { method: "DELETE" });
}
